'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [];

  isCollapsed = true;

  constructor(Auth, $location) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.pathTitle = Auth.pathTitle;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.location = $location;
    this.show = true;

    if (
      $location.path() == "/wanted" ||
      $location.path() == "/direct-dr-member-authors"
    ) {
      this.show = false;
    }

  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js